import { atomWithStorage } from 'jotai/utils';
import { atomEffect } from 'jotai-effect';
import { SocketConnectionWorker } from '../../../components/SocketConnection/CreateWorker';
import { EVENT_IS_OPEN } from '../../../components/SocketConnection/constants';
import { getUserId } from '../../../Services/UserService';
import { browserTabIdAtom } from '../AppState';

/**
 * Jotai atom with localStorage persistence and socket effect
 * Replaces Recoil isGraphOpenAtom
 *
 * Usage:
 *   import { isGraphOpenAtom } from './GraphState';
 *
 *   function MyComponent() {
 *     const [isOpen, setIsOpen] = useAtom(isGraphOpenAtom);
 *     // Effect runs automatically when value changes
 *   }
 */

// Base atom with localStorage persistence
export const isGraphOpenAtom = atomWithStorage<number | false>('isGraphOpen', false);

// Effect atom that sends socket messages when isGraphOpenAtom changes
export const isGraphOpenSocketEffect = atomEffect((get) => {
  const newValue = get(isGraphOpenAtom);
  const browserTabId = get(browserTabIdAtom);

  const data = {
    event: EVENT_IS_OPEN,
    payload: ['graph', newValue],
    userId: getUserId(),
    browserTabId,
  };
  SocketConnectionWorker.postMessage(data);
});

// For backward compatibility - export default function
const setIsGraphOpenToSocketServerEffect = () => isGraphOpenSocketEffect;
export default setIsGraphOpenToSocketServerEffect;
